import { render, staticRenderFns } from "./ApiaryInformationWidgetComponent.vue?vue&type=template&id=15d5c0ec&"
import script from "./ApiaryInformationWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ApiaryInformationWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./ApiaryInformationWidgetComponent.vue?vue&type=style&index=0&id=15d5c0ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports